import { Injectable, NgZone } from '@angular/core';
import { driver } from 'driver.js';
import {BehaviorSubject} from 'rxjs';


@Injectable({ providedIn: 'root' })


export class OnboardingService {

  private onBoardingDesignIsActive$: BehaviorSubject<boolean>;

  private noteSVG = '<svg style="float:left; padding-right: 6px; padding-bottom:0px;" xmlns="http://www.w3.org/2000/svg" height="40px" width="40px" viewBox="0 -960 960 960" fill="#545454"><rect class="note_rect" rx="100" y="-960" height="960px" width="960px" fill="#4b4b4" stroke-opacity="1" fill-opacity="0.9"/><path class="no_pointer_events" xmlns="http://www.w3.org/2000/svg" d="M200-200h360v-200h200v-360H200v560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm80-280v-80h200v80H280Zm0-160v-80h400v80H280Zm-80 360v-560 560Z" fill="white"/></svg>';
  private plusSVG = '<svg style="float:left; padding-right: 6px; padding-bottom:0px;" xmlns="http://www.w3.org/2000/svg" height="40px" width="40px"><circle cx="20" cy="20" r="18" fill="#4b4b4b" stroke="#4b4b4b" stroke-width="1" stroke-opacity="1" fill-opacity="0.9"y/><line x1="32" y1="20" x2="8" y2="20" stroke="white" stroke-width="4" stroke-opacity="1"/><line x1="20" y1="8" x2="20" y2="32" stroke="white" stroke-width="4" stroke-opacity="1"/></svg>';

  private stepsDesign = [
    {
      element: '[data-tour="stepDesign1"]',
      popover: {
        title: 'Neues Design erstellen',
        description:
          'Hier kannst du ein neues Design erstellen. Jedes Design hat seinen eigenen Kartentisch und wird auf dieser Seite als eigene Kachel dargestellt.',
        onNextClick: (element: Element) => {
          element.dispatchEvent(new PointerEvent('pointerup'));
          this.driverObj.moveNext();
        }
      }
    },
    {
      element: '[data-tour="stepDesign2"]',
      popover: {
        title: 'Design benennen',
        description:
          'Jedes Design muss einen eindeutigen Namen haben. Gibst du einen Namen ein, der schon vergeben ist, wird dem Namen automatisch eine Nummer hinzugefügt, um einen eindeutigen Namen zu erzeugen.',
      }
    },
    {
      element: '[data-tour="stepDesign3"]',
      popover: {
        title: 'Design beschreiben',
        description:
          'Hier kannst du deinem Design eine kurze Beschreibung hinzufügen.',
      }
    },
    {
      element: '[data-tour="stepDesign4"]',
      popover: {
        title: 'Design gruppieren',
        description:
          'Du kannst mehrere Designs unter einem gemeinsamen Namen gruppieren. Um eine neue Gruppe anzulegen, gib hier den Namen der Gruppe an. Alternativ kannst du dein Design auch einer bestehenden Gruppe hinzufügen.',
      }
    },
    {
      element: '[data-tour="stepDesign5"]',
      popover: {
        title: 'Design anlegen',
        description:
          'Falls du noch kein Design angelegt und gruppiert hast, fülle jetzt das Feld <strong>Name</strong> aus und gib auch einen <strong>Gruppennamen</strong> an. Klicke anschließend auf <span style="font-style:italic">Speichern</span>.<br/><br/> Hast du bereits ein oder mehrere Designs gruppiert angelegt, kannst du auch direkt auf <span style="font-style:italic">Weiter</span> klicken.',
      }
    },
    {
      element: '[data-tour="stepDesign6"]',
      popover: {
        title: 'Design-Kachel',
        description:
          'Jedes Design wird als eigene Kachel dargestellt. Hast du in dem Design bereits Karten auf dem digitalen Kartentisch liegen, wird das Layout mit bunten Karten skizziert. Damit siehst du für jedes Design, wie und wie viele Karten darin angeordnet sind.<br/><br>Ist dein Design noch leer und ohne Karten, wird ein Icon mit grauen Punkten angezeigt.',
      }
    },
    {
      element: '[data-tour="stepDesign7"]',
      popover: {
        title: 'Design-Menü',
        description:
          'Mit diesem Menü kannst du kannst dein Design ändern, duplizieren, mit anderen teilen oder löschen.',
        onNextClick: (element: Element) => {
          element.dispatchEvent(new PointerEvent('click'));
          this.driverObj.moveNext();
        }
      }
    },
    {
      element: '[data-tour="stepDesign8"]',
      popover: {
        title: 'Design ändern',
        description:
          'Hier kannst du den Namen und die Beschreibung ändern oder dein Design einer anderer Gruppe zuordnen.',
      }
    },
    {
      element: '[data-tour="stepDesign9"]',
      popover: {
        title: 'Design duplizieren',
        description:
          'Hier kannst du eine Kopie deines Designs erstellen, z.B. wenn du von einem Design Varianten erstellen möchtest.',
      }
    },
    {
      element: '[data-tour="stepDesign9b"]',
      popover: {
        title: 'Design teilen',
        description:
          'Hier kannst du dein Design mit anderen aus der EMPAMOS-Community teilen. Ihr könnt dann gemeinsam an einem Design arbeiten. Du kannst wählen, ob man dein Design nur betrachten und es auch verändern darf.',
      }
    },
    {
      element: '[data-tour="stepDesign10"]',
      popover: {
        title: 'Design löschen',
        description:
          'Hier kannst du dein Design löschen. Alle Karten, Verbindungen und Beschriftungen gehen dann dauerhaft verloren.',
      }
    },
    {
      element: '[data-tour="stepDesign11"]',
      popover: {
        title: 'Gruppe ändern',
        description:
          'Mit einem Klick auf den Namen einer Gruppe kannst du die Gruppe umbenennen und damit alle Designs dieser Gruppe umgruppieren. Du hast drei Optionen: <br/><br/>Du kannst einen <strong>neuen Namen</strong> eingeben und alle Designs dieser Gruppe zuordnen.<br/><br/>Gibst du einen bereits <strong>vorhandenen Namen</strong> einer Gruppe ein, verschiebst du alle Designs in diese Gruppe.<br/><br/>Gibst du <strong>keinen Namen</strong> an, verlieren alle Designs ihre Gruppierung.',
      }
    },
  ];

  private stepsEditor = [
    {
      element: '[data-tour="step1"]',
      popover: {
        title: 'Karten auswählen',
        description:
          'Von der <b>Auswahlleiste</b> kannst du Karten per Drag&Drop auf den Kartentisch ziehen. Damit fügst du diese Karte deinem Netzwerk hinzu.',
      },
    },
    {
      element: '[data-tour="step2"]',
      popover: {
        title: 'Karten gezielt suchen',
        description:
          'Verwende die <b>Suchleiste</b>, um gezielt nach Karten zu filtern – z. B. nach Titel oder Kartennummer.',
      },
    },
    {
      element: '[data-tour="step3"]',
      popover: {
        title: 'Kartendeck wechseln',
        description:
          'Wechsel mit Klick auf das Element- oder Misfit-Symbol zwischen <b>Misfit- und Element-Kartendeck</b>.',
      },
    },
    {
      element: '[data-tour="step4"]',
      popover: {
        title: 'Karten gruppieren',
        description:
          'Gruppiere Elementkarten nach <b>Regelkreisphasen</b> und/oder <b>Leitfragen</b> für einen besseren Überblick.',
      },
    },
    {
      element: '[data-tour="step5"]',
      popover: {
        title: 'Kartenansicht vergrößern',
        description:
          'Klicke auf eine Karte, um eine vergrößerte <b>Vorschau</b> zu öffnen. Damit lässt sich der Text besser lesen.',
      },
    },
    {
      element: '[data-tour="step5b"]',
      popover: {
        title: 'Karten aktivieren',
        description:
            'Über den <b>Schieberegler</b> oben rechts kannst du Karten in der Auswahlleiste aktivieren. Damit kannst du dir ein eigenes Kartendeck bauen und steuern, welche Karten die KI-Algorithmen bei ihren Empfehlungen in Betracht ziehen - zusätzlich zu denen, die du bereits auf den Kartentisch platziert hast.',
      },
    },
    {
      element: '[data-tour="step6"]',
      popover: {
        title: 'Digitaler Kartentisch',
        description:
          'Hier platzierst du deine Karten und verbindest sie zu einem Netzwerk. Mit einem Klick auf eine Karte wählst du diese aus und es erscheinen Menü-Icons: <br><br>' + this.noteSVG + ' Mit dem <b>Notiz-Icon</b> kannst du Karten und Verbindungen mit <b>Klebezetteln</b> beschriften.<br><br>' + this.plusSVG + 'Mit dem <b>Plus-Symbol</b> öffnest du das <b>Verbindungsmenü</b>, wo du die von uns dokumentierten Verbindungen nachschlagen kannst.<br><br><b>Tipp:</b> Schnell und einfach kannst du zwei Karten verbinden, wenn du das Plus-Symbol mit der Maus auf eine direkt benachbarte Karte ziehst.',
      },
    },
    {
      element: '[data-tour="step7"]',
      popover: {
        title: 'KI-Funktionen',
        description:
          'Aktiviere die <b>KI-Funktionen</b>, um Vorschläge für passende Kartenverbindungen zu erhalten. Es gibt zwei Modi: Die <b>Erweiterung</b> und die <b>Verdichtung</b>.<br><br>Empfehlungen zur Verdichtung werden dir in Form von <b>grün</b> oder <b>gelb</b> markierten Verbindungsmarkern auf den Karten angezeigt. Auch im <b>Verbindungsmenü</b> werden in diesen Farben die empfohlenen Verbindungen farblich hervorgehoben.',
      },
    },
    {
      element: '[data-tour="step7a"]',
      popover: {
        title: 'KI-Funktion Verdichtung',
        description:
            'Aktiviere hier die KI-Funktion der <b>Verdichtung</b>. Du erhältst dann Empfehlungen, wie du dein Netzwerk noch dichter knüpfen kannst. Die KI fokussiert sich dann nur auf <b>Elemente</b>, die auf deinem Kartentisch liegen oder von dir manuell in der Auswahlleiste aktiviert wurden.<br><br>Bei einer <b>Misfit-Karte</b> werden dir hier hingegen alle Elemente empfohlen, mit denen du das Misfit auflösen kannst. Das können bereits vorhandene, aber auch neue Elemente sein, die du noch nicht in Betracht gezogen hast.',
      },
    },
    {
      element: '[data-tour="step7b"]',
      popover: {
        title: 'KI-Funktion Erweiterung',
        description:
            'Aktiviere hier die KI-Funktion der <b>Erweiterung</b>. Du erhältst dann Empfehlungen, zu <b>Elementen</b>, die du noch nicht auf dem Schirm hattest, aber gut zu denen passen, die du bereits auf dem Kartentisch platziert oder manuell aktiviert hast.<br><br>In diesem Modus analysiert die KI auch dein Netzwerk auf dem Kartentisch und zeigt dir in der Auswahlleiste die <b>Misfits</b>, die sie in deiner Lösung noch vermutet. Hierzu musst du in der Auswahlleiste zum Misfit-Kartendeck wechseln und die Empfehlungen <b>sortieren</b> lassen.',
      },
    },
    {
      element: '[data-tour="step8"]',
      popover: {
        title: 'Sortieren',
        description:
          'Passe die Sortierreihenfolge der Karten an. Ist eine KI-Funktion aktiv, erfolgt die <a>Sortierung nach Empfehlungsstärke</a> – sowohl im Verbindungsmenü als auch in der Auswahlleiste.<br><br><b>Tipp:</b> Hast du keine KI-Funktion aktiviert, kannst du damit in der Auswahlleiste deine manuell <b>aktivierten Karten</b> nach oben holen.',
      },
    },
    {
      element: '[data-tour="step9"]',
      popover: {
        title: 'Hilfe & Legende',
        description:
          'Erhalte einen Überblick über alle Funktionen: KI-Methoden, Gruppierungen, Sortierung sowie die Bedeutung von Farben und Symbolen. Für weiterführende Informationen lade dir die <b>ausführliche Anleitung</b> als PDF herunter.',
      },
    },
    {
      element: '[data-tour="step10"]',
      popover: {
        title: 'Erweiterte Optionen',
        description:
          'Über das Drei-Punkte-Menü kannst du den <b>Kartentisch zurücksetzen</b> oder dein Kartennetz <b>als Bild exportieren</b>.',
      },
    },
    {
      element: '[data-tour="step11"]',
      popover: {
        title: 'Automatisches Speichern',
        description:
          'Ist diese Anzeige blau, ist die <b>Auto-Save-Funktion</b> aktiv und dein Kartennetzwerk wird automatisch im Hintergrund gesichert. Du musst nichts manuell speichern. Ist die Anzeige rot, dann gibt es ein Netzwerkproblem und dein Netzwerk wird nicht gespeichert.',
      },
    },
    {
      element: '[data-tour="step12"]',
      popover: {
        title: 'Zoom und Ansicht',
        description:
          'Vergrößere oder verkleinere die <b>Ansicht deines Kartennetzes</b>. Alternativ kannst du auch das Mausrad nutzen. Mit dem Button „Ansicht zurücksetzen“ wird die Darstellung auf 30 % herausgezoomt, um einen schnellen Gesamtüberblick zu ermöglichen.',
      },
    },
  ];

 driverObj = driver();

  constructor(private ngZone: NgZone){
    this.onBoardingDesignIsActive$ = new BehaviorSubject<boolean>(false);
  }

  startEditorTour(): void {
    this.ngZone.runOutsideAngular(() => {
      this.driverObj = driver({
        showProgress: true,
        nextBtnText: 'Weiter',
        prevBtnText: 'Zurück',
        doneBtnText: 'Fertig',
        animate: true,
        allowClose: true,
        steps: this.stepsEditor,
        onPopoverRender: () => {
          this.replaceText();
        }
      });
      this.driverObj.drive();
  });
  }

  public getDesignOnboardingIsActive() {
    return this.onBoardingDesignIsActive$.asObservable();
  }

  startDesignTour(): void {
    this.onBoardingDesignIsActive$.next(true);
    this.ngZone.runOutsideAngular(() => {
      this.driverObj = driver({
        showProgress: true,
        nextBtnText: 'Weiter',
        prevBtnText: 'Zurück',
        doneBtnText: 'Fertig',
        animate: true,
        allowClose: true,
        steps: this.stepsDesign,
        onPopoverRender: () => {
          this.replaceText();
        },
        onDestroyed: () => {
          this.onBoardingDesignIsActive$.next(false);
        }
      });
      this.driverObj.drive();
    });
  }

  replaceText() {
    const progress = document.querySelector('.driver-popover-progress-text');
    progress.textContent = progress.textContent?.replace('of', 'von');
  }
}
